module.exports = __webpack_public_path__ + "static/media/CFX Advantage_Kotak.9e5e6884.png";